<template>
  <!-- <img src="./assets/logo.png"> -->
  <!-- <div id="app">
    <router-view />
  </div> -->
  <div id="app" v-s.height='H-actived.headerHeight'>

      <preview />

      <keep-alive>
        <mymenu v-if='Appload==="mounted" && isLogin' />
      </keep-alive>

      <div v-if='!$route.meta.rootpage' class="rPos">
        <headers v-show=' !$route.meta.fullscreen ' v-s.height='actived.headerHeight' id='Myheaderbar'></headers>
        <div v-view
            o:pressmove:stop:nosel='return [
              v=>( #this.actived.headerHeight = EE.moveAbsY ), // 移动设置和操作函数
              parseInt(#actived.headerHeight), // 移动初始值
              "y" + #actived.minHeaderHeight,  // 移动最小值
            ]'
            opressmove:stop='
              EE.up ? this.onselectstart = null : this.onselectstart = this.onselectstart||A.returnValue(false);
              if( !EE.move ) return parseInt(#actived.headerHeight);
              if( EE.absY <= 1 ) return;
              const height = #this.actived.headerHeight = Math.max(EE.Dtemp+EE.moveY,#actived.minHeaderHeight);
              return height;
              // console.error(height,EE);
              // return $(e).$prev().style.height = height + "px", height;
            '
            o:dblclick:stop='#this.actived.headerHeight = #actived.minHeaderHeight'
            title="拖拽移动, 双击还原"
            style="position: absolute;width: 100%;height: 5px;left: 0px;bottom: 0px;cursor: row-resize;"></div>
      </div>

      <div class="flex">
        <!-- 如果是 <非退出> 的路由页面 -->
        <div v-if='!$route.meta.rootpage'>
          <!-- 如果是独立的满屏页面, 那么不会显示菜单栏和导航栏 -->
          <div v-show=' !$route.meta.fullscreen ' style="display:flex;width:100%;border-bottom: 1px solid #ccc;box-shadow: 0px 0px 2px #ccc;">
            <div class='bBox' style="border-right: 1px solid #dfdedf;box-shadow: 2px 2px 2px 2px#f3f3f3;">
                <navs id="Mymenubar"></navs>
            </div>
          </div>
        </div>

        <div id='Myrouterview' ref='Myrouterview' style="width: 100%;height:100vh;overflow: auto;" v-s.padding.max-height.overflow=' $route.meta.fullscreen ? [ 0, "", "hidden" ] : [ "10px", "calc(100vh - 70px)", "auto" ] '>

          <!-- 调试的时候用 -->
          <!-- <router-view x:key='excludeKey' notkeepalive ></router-view> -->

          <router-view v-if=' excludeKey[0] === "$" && $route.meta.key[0] === "$" ' :key='excludeKey' notkeepalive ></router-view>

          <keep-alive x:include='$route.name' :exclude='( activeDate, excludeKey )' >
            <router-view v-if=' excludeKey[0] !== "$" || $route.meta.key[0] !== "$" '
              :key='( activeDate, $route.meta.key )' keepalive></router-view>
          </keep-alive>

        </div>
      </div>

  </div>

</template>

<script>
// import Vue from 'vue';
// import index from './index.vue';
import navs from "@/components/$navs.local";
import headers from "@/components/$headers.local";
import preview from "@/components/$Preview.local.vue";

let W = window, $Menus = W.$Menus, $Routers, $metas, Now = W.Date.now, handler;
// console.error(11111111, $Routers);
const Closemenu = $Menus.closemenu;
const Gohomepage = function(from){
  // from !== from && ( this.$route.meta.rootpage = from );
  this.$push( this.homepage );
};
const Gorootpage = function(){
  // this.$route.meta.$Gorootpage = true;
  var tmp;
  A.clearLocal( App.ifExistLogin );
  A.clearLocal( A.loginTypeword );
  A.clearLocal('$Userinfo'), A.clearLocal('$Usertoken'), A.clearLocal('isCustomer'), A.clearLocal('$projectName');
  A.reset$MyTableList$();
  const _Apis = W.Apis;
  forObj( tmp = W.$_Prototrigger, (v,k)=>{
    tmp[k] = _Apis[k] = null;
    return;
  } );
  this.isLogin = false;
  this.$router.replace( this.rootpage );
  return;
};
export default {
  name: "App",

  components: {
    headers,
    navs,
    preview,
    // index,
  },

  computed: {

  },

  data() {
    const actived = $Menus.actived;
    return {
      // headerHeight: 47,
      // minHeaderHeight: 47,
      actived: actived,
      activeDate: '',
      activedKey: '',
      excludeKey: '',
      isLogin: true,
      Appload: false,
      forceRefresh: false,
    };
  },
 
  watch: {
    activeDate: {
      handler: handler = function(){
        const meta = this.$route.meta;
        // console.error( meta, meta.refresh, meta.notkeepalive );
        return meta.key =

          meta.notkeepalive

          ? this.excludeKey = meta.key || '$' + Now()

          : meta.refresh

          ? ( this.$nextTick(()=>meta.refresh = false), this.excludeKey = Now() + '' )

          : ( meta.key || Now() ) + '';
      },
      immediate: true
    },
    $route: handler
  },

  created() {
    // console.warn(777777777, $Menus.actived );
    $Menus.actived.headers = this;
    ( W.App = this ).closemenu = Closemenu;
  },

  mounted: async function() {
    $Routers = $Routers || W.$Routers, $metas = $Routers.$metas;
    const $App = W.App = this; // 将App页面的Root对象挂载到window全局
    Appload = W.Appload = this.Appload = 'loaded';
    $App.ifExistLogin = A.ifExistLogin;

    $App.rootpage = $metas.rootpage;
    $App.homepage = $metas.homepage;
    $App.Gohomepage = Gohomepage;
    $App.Gorootpage = Gorootpage;

    await $App.$nextTick();
    Appload = (W.Root.App = $App ).Appload = W.Appload = 'mounted';
  },


};
</script>

<style>
.el-step__head.is-wait{
  display: none !important;
}
/*#app {
  font-family: "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
html,
body {
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: 100%;
  background-color: white;
  overflow: hidden;
}*/
/*.msgBox {
  width: 100%;
  border-bottom: 1px solid #ccc;
  box-shadow: 0px 0px 2px #ccc;
}
.msgBox .msgLeft {
  border-right: 1px solid #dfdedf;
  box-shadow: 2px 2px 2px 2px#f3f3f3;
  box-sizing: border-box;
}
.msgBox .msgRight {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  padding: 10px;
  position: relative;
  box-sizing: border-box;
}*/

a {
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}
* {
  margin: 0;
  padding: 0;
}
button {
  cursor: pointer;
}
form {
  display: inline;
}

.el-input__prefix {
  left: 10px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}
.el-submenu .el-menu-item {
  height: 40px;
  line-height: 40px;
  padding: 0 45px;
  min-width: 200px;
}
.el-menu {
  border-right: 0;
}
.el-tag {
  font-size: 10px;
}
.el-checkbox-group {
  font-size: 12px;
}
.el-tag + .el-tag[data-v-178cb97c] {
  margin-left: 0;
}
.el-tag {
  margin: 0 10px 10px 0;
}
.el-checkbox {
  display: block;
  position: relative;
  white-space: nowrap;
}
.el-checkbox__label {
  padding-left: 10px;
  line-height: 19px;
  font-size: 14px;
}
.diabox .el-dialog {
  width: 35% !important;
}
/*.el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 98px;
  height: 98px;
  line-height: 96px;
  vertical-align: top;
}
.el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 98px;
  height: 98px;
  line-height: 96px;
  vertical-align: top;
}
.el-upload-list--picture-card .el-upload-list__item {
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 98px;
  height: 98px;
  margin: 0 8px 8px 0;
  display: inline-block;
}*/
.el-checkbox__label {
  font-size: 12px !important;
}
.textareas .el-textarea__inner {
  height: 80px !important;
}
.intworp .el-form-item {
  margin-bottom: 5px;
}
.el-dropdown .el-dropdown-link {
  color: #fff;
}
.el-submenu__title {
  font-size: 14px;
  /* color: #fff; */
  color: #000;
  padding: 0 20px;
  /* background: #428bca; */
  background-color: #fff;
  cursor: pointer;
  -webkit-transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-submenu__title i {
  color: #fff;
}
.el-submenu__title:hover {
  color: #606266;
}
.el-submenu__title:hover i {
  color: #606266;
}
.tit-width .el-checkbox {
  display: inline-block;
}
.tit-width .el-checkbox__label {
  font-size: 14px !important;
}

.el-button.is-circle {
  border-radius: 50%;
  padding: 8px;
}
.intworp .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #409eff;
  border-color: #409eff;
}
.intworp .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #000;
  /* cursor: not-allowed; */
}
.search-box .el-input__inner {
  background: #fbfbfb;
  border: 1px solid #d5d5d5;
  border-radius: 0;
}
.inputBoxs .el-input__inner {
  width: 100%;
}
.selsctL1 .el-input__inner {
  width: 120px;
}
.stepText .el-step__title {
  font-size: 14px;
  line-height: 25px;
}
.el-step__head.is-success {
  color: #428bca;
  border-color: #428bca;
}
.el-step__title.is-success {
  color: #428bca;
}
.el-step__head.is-process {
  color: #999;
  border-color: #999;
}
.el-step__title.is-process {
  font-weight: 700;
  color: #999;
}
.inputmsg .el-radio-button__inner {
  width: 100%;
}
.codeDia .el-dialog--center .el-dialog__body {
  padding: 30px 50px 30px;
  box-sizing: border-box;
}

.el-dropdown {
  display: inline-block;
  position: relative;
  color: #606266;
  font-size: 16px;
}
.el-col-offset-0 {
  margin: 20px 2% 0 2% !important;
}
.el-col-offset-2 {
  margin: 20px 2% 0 2% !important;
}
.image[data-v-ec1967ec] {
  width: 100%;
  height: 150px;
  display: block;
}
.el-carousel__container {
  position: relative;
  height: 350px !important;
}
.hello .el-popover {
  width: 80px;
  bottom: 45px;
  left: 0;
  right: 0;
  padding: 0;
  position: fixed !important;
  min-width: 80px !important;
  margin: auto;
}
.el-button--mini,
.el-button--mini.is-round {
  padding: 5px 10px;
}
/* .el-table td {
  border-bottom: 0;
}
.el-table .cell,
.el-table th div,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  padding-left: 0px;
} */
.el-table .cell,
.el-table th div {
  padding-right: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-table th > .cell {
  text-align: center;
}
.el-table .cell {
  text-align: center;
}
.el-table td,
.el-table th {
  padding: 8px;
  min-width: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
}

.el-menu-item-group__title {
  padding: 0;
}
.el-menu-item,
.el-submenu__title {
  height: 40px !important;
  line-height: 40px !important;
  font-size: 14px;
  position: relative;
  -webkit-box-sizing: border-box;
  white-space: nowrap;
  list-style: none;
  border-bottom: 1px solid #ccc;
}
</style>



<div id="app">

    <div>
    <!-- 如果是 <非退出> 的路由页面 -->
    <div v-if='_error($route.meta) && !$route.meta.rootpage'>
      <!-- 如果是独立的满屏页面, 那么不会显示菜单栏和导航栏 -->
      <div v-show=' !$route.meta.fullscreen ' id="Mysysmain">
        <mymenu></mymenu>

        <headers v-s.height='headerHeight' id='Myheaderbar'></headers>

        <div class='flex' style="width:100%;border-bottom: 1px solid #ccc;box-shadow: 0px 0px 2px #ccc;">
          <div class='bBox' style="border-right: 1px solid #dfdedf;box-shadow: 2px 2px 2px 2px#f3f3f3;">
            <navs></navs>
          </div>
        </div>

      </div>
    </div>

    <div id='Myrouterview' v-s.height='H-headerHeight'>

      <router-view vif='!$route.meta.keepalive' :key='activeDate' notkeepalive></router-view>

      <!-- <keep-alive x:include='$route.meta.keepalive' xinclude='login'>
        <router-view vif='!$route.meta.keepalive' x:key='activeDate' keepalive></router-view>
      </keep-alive> -->

    </div>

    </div>

  </div>



  <remark 成功实现静态+动态刷新的案例 ::>
  <keep-alive x:include='$route.name' :exclude='( activeDate, _warn( excludeKey, "::排除..." ) )' >

      <router-view vif='$route.meta.loaded >= 2'
        :key='( activeDate,

          _warn( $route.meta.key,  $route.meta.refresh = false,

            "::key"
          )

        )' keepalive></router-view>

    </keep-alive>



// WEBPACK FOOTER //
// src/App.vue